import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';

import Box from '../../elements/Box';
import Text from '../../elements/Text';

const Legend = (props) => {
  const { legendPrice, legendToday, showLegendPrice, showLegendToday } = props;
  const { translate, direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });
  return (
    <Box className={`${className} fr-clearfix`} style={style} dataTestId="legend">
      {showLegendPrice && (
        <Text {...legendPrice} floatLeft marginRight="1">
          {translate('cmp-legend-lowest-price', 'Lowest Price')}
        </Text>
      )}
      {showLegendToday && (
        <Text border {...legendToday} floatLeft>
          {translate('cmp-legend-today', 'Today')}
        </Text>
      )}
    </Box>
  );
};

Legend.propTypes = {
  /**
   * Props of legendPrice
   */
  legendPrice: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of legendToday
   */
  legendToday: PropTypes.objectOf(PropTypes.any),
  /**
   * Turn off or on the showLegendPrice item
   */
  showLegendPrice: PropTypes.bool,
  /**
   * Turn off or on the showLegendToday item
   */
  showLegendToday: PropTypes.bool,
  /**
   * Translation key of the legendPrice
   */
  legendPriceLabelKey: PropTypes.string,
  /**
   * Translation key of the legendToday
   */
  legendTodayLabelKey: PropTypes.string,
};

Legend.defaultProps = {
  legendPriceLabelKey: 'cmp-legend-lowest-price',
  legendTodayLabelKey: 'cmp-legend-today',
  legendPrice: {},
  legendToday: {},
  showLegendPrice: true,
  showLegendToday: true,
};

export default Legend;
